import bowser from 'yola-bowser';
import { connectedStore } from '../../../store';
import instance from '../../instance';
import view from '../../../view';

const S_KEY = 's';

const blurElementOnSaveHotkey = (event) => {
  const { ctrlKey, key, metaKey } = event;

  const isLinux = bowser.linux;
  const isMacOS = bowser.macOS;
  const isWindows = bowser.windows;

  const store = connectedStore.get();

  const keyLoweCase = key.toLowerCase && key.toLowerCase();

  let isSave;
  if (isMacOS) {
    isSave = keyLoweCase === S_KEY && metaKey;
  } else if (isWindows || isLinux) {
    isSave = keyLoweCase === S_KEY && ctrlKey;
  }

  if (isSave) {
    event.preventDefault();
    event.stopPropagation();

    // Save hotkey was disabled because it doesn't work correctly, we got a regression here.

    // if (event.srcElement.isContentEditable) {
    //   const elementId = instance.driver.referenceMap.getReferenceId(event.srcElement);
    //
    //   // blur then reset focus on contenteditable element
    //   // to ensure changes are saved
    //   store.dispatch(view.actions.blurFocusedElement());
    //   store.dispatch(view.actions.setFocusedElement(elementId));
    // }
  }
};

export default blurElementOnSaveHotkey;
